import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Widget_types_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="widget_types" />;
  }
}
